import type { FaireProductEntity } from "../../entity_types/product";

export const p_nhvkrcd5eg: FaireProductEntity = {
  token: "p_nhvkrcd5eg",
  type: "product",
  name: "Seasonal Display Box (Empty holds 24+ Single Serve Cocktails",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/64da601a3c2ea8825afa885bb795c9b3d2b22c17f367303e7a1c22963b5575c9.jpeg",
  galleryImageUrls: [],
  priceDollars: 0.01,
  description:
    "Empty Seasonal Display Box. This display box holds 2 Dozen+ Single Serve Cocktails. Its free with purchase of 2 Dozen or more Of Any Cocktail.\n\nYou MUST add this display box to your order. \nThey won't automatically be sent with orders. \n\nThis is one of the 2 FREE ways we provide to merchandise our cocktails.  Also check out our Spinner Packages.",
  tags: [],
  msrpDollars: 0.02,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:00.500Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
